import React from "react";
import { NavLink } from "react-router-dom";

const navItems = [
  { label: "Ingestion History", key: "ingestion-history" },
  { label: "POS Connection", key: "pos" },
  { label: "Categories Mapping", key: "categories-mapping", requiresPos: true },
  { label: "Product Mapping", key: "product-mapping", requiresPos: true },
  { label: "Rules", key: "rules" },
];

const LeftNav = ({ selected, hasPosConnection, posCheckLoading }) => (
  <nav className="w-72 p-6 border-r border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 min-h-full">
    <ul className="space-y-2">
      {navItems.map((item) => {
        const disabled = item.requiresPos && !posCheckLoading && !hasPosConnection;
        if (disabled) {
          return (
            <li key={item.key}>
              <span
                className="block w-full text-left px-3 py-2 rounded font-medium text-slate-400 dark:text-slate-500 cursor-not-allowed select-none"
                title="Connect a POS to enable"
              >
                {item.label}
              </span>
            </li>
          );
        }
        return (
          <li key={item.key}>
            <NavLink
              to={`/external-feeds/${item.key}`}
              className={({ isActive }) =>
                `block w-full text-left px-3 py-2 rounded font-medium transition-colors duration-150 ${
                  isActive
                    ? "bg-indigo-100 text-indigo-700 dark:bg-indigo-900 dark:text-indigo-200"
                    : "text-slate-700 dark:text-slate-200 hover:bg-slate-100 dark:hover:bg-theme-surface-accent"
                }`
              }
              end={item.key === "ingestion-history"}
            >
              {item.label}
            </NavLink>
          </li>
        );
      })}
    </ul>
  </nav>
);

export default LeftNav;